export const WHITE      = '#FFF'
export const BLACK      = '#000'
export const PRIMARY    = '#003C7F'
export const SECONDARY  = '#00ADEE' 
export const BLUE       = '#00ADEE'
export const DARK_BLUE  = '#003C7F'
export const HOVERBTN   = '#003C7F'
export const GREY       = '#6c6c6c'
export const GREY_LIGHT = '#FBFBFB'
export const GREY_BOX   = '#CFD7D9'
export const GREY_HEADER= '#BEBEBE'
export const GREY_INPUT = '#707070'
export const TITLE_FONT = '#00ADEE'
export const GREY_FONT  = '#B1ADAD'
export const GREEN      = '#87C15F'
